export default __webpack_public_path__ + "static/media/codrops.7d3c7632.svg";